import React from "react";

type ArrowProps = {
  direction: "left" | "right";
  color?: string;
};

const Arrow: React.FC<ArrowProps> = ({ direction, color }) => {
  if (direction === "left")
    return (
      <svg
        width="22"
        height="40"
        viewBox="0 0 22 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 2L2 20L20 38"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

  return (
    <svg
      width="22"
      height="40"
      viewBox="0 0 22 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 2L20 20L2 38"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Arrow;
